import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import {isLanguagePresent, isPresent} from "../../utils/utils";


// displayLanTxtFirst inverte l'ordine di default, mostrando la sigla della lingua prima della bandiera
const LanguageFlag = ({ language, maxHeight, cssClassList, displayRoundFlag, displayLanTxt, displayLanTxtFirst, containerCssClassList }) => {

  const flag =
    <img src={window.location.origin + `/images/${displayRoundFlag ? 'langs/' + language?.toLowerCase() + '.svg' : 'flags/' + language?.toLowerCase() + '.png'}`}
         style={{ height: maxHeight ? maxHeight : "20px" }}
         className={cssClassList ? cssClassList : "mb-1"}
         alt=""
    />

  const languageText =
    displayLanTxt &&
      <span className={`text-wrap text-truncate ${displayLanTxtFirst ? 'mr-2' : 'ml-2'}`}>
        { language !== 'native' ? language.toUpperCase() : I18n.t('js.editSubmissionListPage.webComponent.draft.labelLanguageOption.nativeCompact')}
      </span>

  return <React.Fragment>
    {
      isLanguagePresent(language) &&
        <div className={isPresent(containerCssClassList) ? containerCssClassList : 'd-flex'}>
          {
            displayLanTxtFirst ?
              <React.Fragment>{languageText}{flag}</React.Fragment>
              :
              <React.Fragment>{flag}{languageText}</React.Fragment>
          }
        </div>
    }
  </React.Fragment>
};

export default LanguageFlag;